import axios from "axios";
import { apiURL } from "../config/default";

import { alert } from "./alert";
import setAuthHeader from "../utils/setAuthHeader";
import { USER_UPDATE_SUCCESS, USER_UPDATE_FAIL } from "./types";
export const updateUser = ({
  _id,
  email,
  firstName,
  lastName,
  phone,
}) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }

  const body = JSON.stringify({
    _id,
    email,
    firstName,
    lastName,
    phone,
  });

  try {
    const res = await axios.post(`${apiURL}user-update`, body, _config);
    dispatch({
      type: USER_UPDATE_SUCCESS,
      payload: res.data,
    });
    return res;
  } catch (err) {
    const errors = err.response.data.error;

    dispatch({
      type: USER_UPDATE_FAIL,
    });
    return err;
  }
};
